export const SET_TLS_SUPPORT_VALUE = 'tls//SET_TLS_SUPPORT_VALUE';
export const SET_TLS_ERROR = 'tls//SET_TLS_ERROR';

export function setTlsSupport(payload) {
  return {
    type: SET_TLS_SUPPORT_VALUE,
    payload
  };
}

export function setTLSError(errorMessage) {
  return {
    type: SET_TLS_ERROR,
    errorMessage
  };
}

const initialState = {
  isTlsSupported: false,
  error: undefined
};

export default function(state = initialState, action) {
  switch (action.type) {
    case SET_TLS_SUPPORT_VALUE:
      return {
        ...state,
        isTlsSupported: action.payload,
        error: undefined
      };
    case SET_TLS_ERROR:
      return {
        ...state,
        error: action.errorMessage
      };

    default:
      return state;
  }
}
